import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Axios from 'axios';
import { soundcastManager, publisherManager, paymentManager } from '../../../helpers/managers';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import getPath from 'lodash/get';
import moment from 'moment';
import styled from 'styled-components';
import Colors from '../../../styles/colors';
import getCurrency from '../../../helpers/getCurrency';
import { checkPaymentCard } from '../../../helpers/payments';
import { getUserPlatformCustomerId  } from '../../../helpers/userinfoHelper';
import { CardNumberInput, CardExpiryInput, CardCVCInput, CardCountrySelect, CardZipInput } from '../../../components/payments';
import { PayButton } from '../../../styles/checkout';
import Loading from '../../../components/Loading';
import PoweredBySoundwise from '../../checkout/PoweredBySoundwise';
const { encodeStripePlanID } = require('../../../../server/scripts/utils')();

class _Payment extends Component {
  constructor(props) {
    super(props);
    const { listenerInfo = {} } = this.props || {};

    this.state = {
      paymentError: '',
      firstName: listenerInfo.firstName || '',
      lastName: listenerInfo.lastName || '',
      email: listenerInfo.email || '',
      cardType: '',
      number: '',
      cvc: '',
      exp_month: 0,
      exp_year: new Date().getFullYear(),
      address_zip: '',
      address_country: 'US',
      startPaymentSubmission: false,
    };

    this.updatePropsLock = false;
    this.onSubmit = this.onSubmit.bind(this);
    this.stripeTokenHandler = this.stripeTokenHandler.bind(this);
    this.renderProgressBar = this.renderProgressBar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePaymentCard = this.handlePaymentCard.bind(this);
    this.updateProps = this.updateProps.bind(this);
    window.newUserOrSoundcast = true;
    window.confirmationEmailSent = false;
  }

  componentDidMount() {
    if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'staging') {
      console.log('Stripe: setting test key');
      Stripe.setPublishableKey('pk_test_BwjUV9yHQNcgRzx59dSA3Mjt');
    } else {
      Stripe.setPublishableKey('pk_live_rR36Qeypo5CrbG1FKgE1XdlL');
    }
    this.updateProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateProps(nextProps);
  }

  updateProps(props) {
    // set newUserOrSoundcast for mailchimp update
    const isSameUserEmail = isEqual(this.props.userInfo.email, props.userInfo.email);
    const isSameSoundcast = isEqual(this.props.soundcastID, props.soundcastID);
    if (!isSameUserEmail || !isSameSoundcast) {
      window.newUserOrSoundcast = true;
    }
  }

  handleChange(e) {
    if (e.target.value) {
      // cache values (bug #58)
      if (e.target.name === 'firstName') {
        localStorage.setItem('soundwiseSignupFName', e.target.value);
      }
      if (e.target.name === 'lastName') {
        localStorage.setItem('soundwiseSignupLName', e.target.value);
      }
      if (e.target.name === 'email') {
        localStorage.setItem('soundwiseSignupEmail', e.target.value);
      }
    }

    this.setState({ [e.target.name]: e.target.value });
  }

  handlePaymentCard(statekey) {
    return value => {
      if (statekey === 'expiry') {
        const prefix = new Date().getFullYear().toString().substr(0, 2);

        // parse value coming from autofill
        if (isArray(value) && value[0].includes('/')) {
          value = value[0].split('/');
        }

        const [month, year] = value;
        return this.setState({
          exp_month: isEmpty(month) ? '' : Number(month),
          exp_year: isEmpty(year) ? '' : Number(`${prefix}${year}`),
        });
      }

      this.setState({
        [statekey]: value,
      })
    };
  }

  async onSubmit(event) {
    event.preventDefault();

    // skip card input, when the price is free or 0
    if (this.props.hideCardInputs) {
      return this.props.handleStripeId(null, this.state);
    }

    // do not proeed, if the payment is in process
    if (this.state.startPaymentSubmission) {
      return false;
    }

    const { number, cvc, exp_month, exp_year, address_country, address_zip } = this.state;
    const cardInfo = {
      number,
      cvc,
      exp_month,
      exp_year,
      address_country,
      address_zip,
    };

    this.setState({
      startPaymentSubmission: true,
      paymentError: null,
      tokenCheck: true,
    }, async () => {
      const cardCheckError = await new Promise(resolve => {
        Stripe.card.createToken(cardInfo, async (status, response) => {
          if ('error' in response) {
            return resolve(response.error.message);
          }
          const { id: tokenId } = response || {}; 
          if (isEmpty(tokenId)) {
            return resolve(`Card source token creating error.`);
          }
          try {
            const checkResult = await checkPaymentCard(tokenId) || {};
            const success = getPath(checkResult, 'data.success', false);
            if (success) {
              return resolve( null );
            }
          } catch (err) {
            const errorMessage = getPath(err,
              'response.data.message',
              `${err.message || 'Unknown error'}.`
            );
            return resolve(errorMessage);
          }
          resolve('Unknown error.');
        });
      });
      const startPaymentSubmission = isEmpty(cardCheckError);
      const paymentError = startPaymentSubmission
        ? null
        : `Card check is failed. ${cardCheckError} Please check your credit card information.`;
      const tokenCheck = false;
      this.setState({
        startPaymentSubmission,
        paymentError,
        tokenCheck,
      }, () => {
        if (startPaymentSubmission) {
          Stripe.card.createToken(cardInfo, this.stripeTokenHandler);
        }
      });
    });
  }

  async stripeTokenHandler(_, token) {
    const {
      userInfo,
      soundcastID,
      soundcast,
      checked,
      coupon = '',
      isTrial,
      handleStripeId,
      onPaymentSuccess,
    } = this.props;
    const { id: userId, email, stripe_id = '' } = userInfo;
    const firstName = userInfo.firstName || this.state.firstName;
    const lastName = userInfo.lastName || this.state.lastName;
    const fullname = `${firstName} ${lastName}`;
    const receipt_email = (email && email[0]) || this.state.email;
    const { address_country: country = '', address_zip: postal_code = '' } = this.state;
    let { billingCycle, paymentPlan, price, currency = 'USD' } = soundcast.prices[checked];

    // if user is not logged in, try to retrieve the stripe_id
    // from firebase, in case the provided email does exist on our account system
    const platformCustomer = isEmpty(stripe_id)
      ? await getUserPlatformCustomerId(receipt_email)
      : stripe_id;

    if (isEmpty(billingCycle)) {
      billingCycle = 'one time'; // treat empty string as "one time"
      soundcastManager.saveProp(
        soundcastID,
        `prices/${checked}/billingCycle`,
        billingCycle
      );
    }

    // if stripe token failed
    if (token.error) {
      return this.setState({
        paymentError: token.error.message,
        startPaymentSubmission: false,
      });
    }

    // handle response
    try {
      const { publisherID, title } = soundcast;

      const publisher = await publisherManager.getById(publisherID);
      if (isEmpty(publisher)) {
        throw new Error(`Unable to process the payment. Soundcast owner does not exist.`);
      }

      const { stripe_user_id: publisherStripeId = '' } = publisher;
      if (isEmpty(publisherStripeId)) {
        throw new Error(`Unable to process the payment. Soundcast owner has missing payment configuration.`);
      }

      const isOneTime = isEqual(billingCycle, 'one time');
      const isRental = isEqual(billingCycle, 'rental');
      const checkoutDetails = {
        source: token.id,
        userId,
        receipt_email,
        platformCustomer,
        stripe_account: publisherStripeId,
        soundcastID,
        coupon,
        fullname,
        address: {
          country,
          postal_code,
        },
      };

      const payment = await new Promise(async (resolve, reject) => {
        try {
          const xDebug = {
            // to save to the log on the server
            xsrc: 'webapp',
            ...(isEmpty(userInfo) ? {} : { xuser: {
              ...(isEmpty(userInfo.email) ? {} : { email: userInfo.email }),
              ...(isEmpty(userInfo.id) ? {} : { id: userInfo.id }),
            }}),
          };

          await paymentManager.removeSouncastPayment(receipt_email, soundcastID); // clear paystate

          if (isOneTime || isRental) {
            // this api always returns 200 (because of it was written in loopback)
            const { data } = await Axios.post('/api/transactions/handleOnetimeCharge', {
              ...checkoutDetails,
              plan: {
                billingCycle,
                paymentPlan,
                price,
                currency: currency.toLowerCase(),
              },
              ...xDebug,
            });

            const { success, message, charge = {} } = data;
            if (!success && !isEmpty(message)) {
              console.log(`One time charge error:`, message);
              throw new Error(
                `Your payment is declined. ${message} Please check your credit card information.`,
              );
            }

            const { paid = false } = charge;
            if (!paid) {
              throw new Error('Your payment failed. Please check your credit card information.');
            }

            return resolve(charge);
          }

          // if subscription, post to api/recurring_charge
          try {
            const planID = encodeStripePlanID({ publisherID, soundcastID, title, billingCycle, price });

            const { data: subscription } = await Axios.post('/api/recurring_charge', {
              ...checkoutDetails,
              planID,
              publisherID,
              isTrial,
              ...xDebug,
            });

            if (isEmpty(subscription)) {
              throw new Error('Subscription is empty');
            }

            const paystate = await paymentManager.getSoundcastPaymentDelay(receipt_email, soundcastID, 18);
            if (isEmpty(paystate)) {
              throw new Error(
                `It was not possible to obtain payment status information. ` +
                `Do not re-pay now as processing may complete later. ` +
                `After a while, check "MY LIBRARY"`
              );
            } else {
              const {
                success = false,
                lastPaymentError = 'UNKNOWN ERROR',
                eventData = {},
              } = paystate;
              if (!success) {
                throw new Error(
                  `Your payment is declined. ${lastPaymentError} Please check your credit card.`,
                );
              }
              const { id: paySubscriptionId } = subscription || {};
              const { subscriptionId } = eventData || {};
              if (isEqual(paySubscriptionId, subscriptionId)) {
                await paymentManager.removeSouncastPayment(receipt_email, soundcastID); // clear success paystate
              }
            }

            resolve(subscription);
          } catch (err) {
            console.log(`Recurring charge error`, err.message);
            throw new Error('Your payment subscription failed. Please check your credit card information.');
          }
        } catch (err) {
          reject(err);
        }
      });

      const { metadata } = payment || {};
      const { userId: mUserId = '' } = metadata || {};

      // if payment made, push course to user data, and redirect to a thank you page
      if (!isEmpty(mUserId) || (userInfo && userInfo.email)) {
        return onPaymentSuccess(payment);
      }

      handleStripeId(payment, this.state);
    } catch (err) {
      this.setState({
        paymentError: err.message,
        startPaymentSubmission: false,
      });
    }
  }

  renderProgressBar() {
    return (
      <ProcessingBar>
        <Loading text="Processing" align="center" size={60} fontSize={1.6} />
      </ProcessingBar>
    );
  }

  renderPayBtn() {
    const { startPaymentSubmission: processing, tokenCheck = false } = this.state;
    const btnContent = processing ? (
      <Loading
        text= {tokenCheck ? "Card check" : "Processing"}
        type="circle"
        align="center"
        size={30}
        fontSize={1.6}
        color="#fff"
        fill="#fff"
      />
    ) : 'PAY NOW';

    return (
      <CustomPayButton
        id="paymentPayNowBtnTest"
        className={`btn text-white width-100 ${processing ? 'disabled' : ''}`}
        type="submit"
      >
        {btnContent}
      </CustomPayButton>
    );
  }

  render() {
    const {
      email, firstName, lastName,
      paymentError, startPaymentSubmission, cardType, address_country, address_zip,
    } = this.state;
    const { totalPrice, hideCardInputs, soundcast, checked, isFree, isTrial } = this.props;

    // if free soundcast just process the payment
    // and showw a loading indicator
    if (isFree && !isTrial) {
      return this.renderProgressBar();
    }

    // if no user is detected, show input asking basic user details
    const showInputs = !(this.props.userInfo && this.props.userInfo.firstName);
    // const showInputs = true;

    const monthOptions = [];
    const yearOptions = [];
    for (let i = 0; i < 12; i++) {
      monthOptions.push(
        <option value={i} key={i}>
          {moment()
            .month(i)
            .format('MMM (MM)')}
        </option>
      );

      yearOptions.push(
        <option value={i + +moment().format('YYYY')} key={i}>
          {i + +moment().format('YYYY')}
        </option>
      );
    }

    const pricing = soundcast.prices[checked];
    const currency = getCurrency(pricing);

    return (
      <CreditCardForm onSubmit={this.onSubmit}>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 ">
            <TotalPrice>
              <div className="total-text text-extra-large">Total</div>
              <div className="total-price-text title-small font-weight-700">{`${currency} ${Number(totalPrice).toFixed(2)}`}</div>
            </TotalPrice>
          </div>
        </div>

        <div className="row">
          {showInputs && (
            <React.Fragment>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <input
                  onChange={this.handleChange}
                  required
                  className="border-radius-4"
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  style={styles.input}
                  defaultValue={firstName}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <input
                  onChange={this.handleChange}
                  required
                  className="border-radius-4"
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  style={styles.input}
                  defaultValue={lastName}
                />
              </div>
            </React.Fragment>
          )}
        </div>

        <div className="row">
          <div className="col-lg-12">
            {showInputs && (
              <input
                onChange={this.handleChange}
                required
                className="border-radius-4"
                type="email"
                name="email"
                placeholder="Email"
                style={styles.input}
                defaultValue={email}
              />
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <CardZipInput
              onChange={this.handlePaymentCard('address_zip')}
              required
              className="border-radius-4"
              name="address_zip"
              placeholder="Zip Code"
              style={styles.input}
              defaultValue={address_zip}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <CardCountrySelect
              autoDetectCountry={true}
              onChange={this.handlePaymentCard('address_country')}
              required
              name="address_country"
              style={styles.input}
              defaultValue={address_country}
            />
          </div>
        </div>

        <div className="row"><div className="col-md-12"><br/></div></div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card-number-wrapper">
              {!hideCardInputs && (
                <div className="card-number-wrapper">
                  <div className="card-logos">
                    <img src="../../../images/svg/visa.svg" style={styles.cardsImage} alt="image"/>
                    <img src="../../../images/svg/mastercard.svg" style={styles.cardsImage} alt="image"/>
                    <img src="../../../images/svg/amex.svg" style={styles.cardsImage} alt="image"/>
                    <img src="../../../images/svg/discover.svg" style={styles.cardsImage} alt="image"/>
                  </div>
                  <CardNumberInput
                    onChange={this.handlePaymentCard('number')}
                    onCardChange={this.handlePaymentCard('cardType')}
                    required
                    className="border-radius-4"
                    size="20"
                    name="number"
                    placeholder="0000 0000 0000 0000"
                    style={styles.input}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          {!hideCardInputs && (
            <React.Fragment>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <CardExpiryInput
                  onChange={this.handlePaymentCard('expiry')}
                  required
                  className="border-radius-4"
                  size="4"
                  name="cvc"
                  placeholder="MM/YY"
                  style={styles.input}
                />
              </div>

              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <CardCVCInput
                  onChange={this.handlePaymentCard('cvc')}
                  cardType={cardType}
                  required
                  className="border-radius-4"
                  size="4"
                  name="cvc"
                  placeholder="CVC"
                  style={styles.input}
                />
              </div>
            </React.Fragment>
          )}
        </div>

        {paymentError && (
          <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
              <div className="alert alert-danger" role="alert">
                {paymentError}
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-lg-12">
            {(hideCardInputs && (
              <div>
                <button
                  type="submit"
                  className="contact-submit btn propClone btn-3d text-white width-100 builder-bg tz-text"
                  style={{ ...styles.button }}
                >
                  SUBMIT
                </button>
              </div>
            )) || (
              <div>
                {this.renderPayBtn()}
                <PoweredBySoundwise />
              </div>
            )}
          </div>
        </div>
      </CreditCardForm>
    );
  }
}

const mapStateToProps = state => {
  return { isEmailSent: state.user.isEmailSent };
};
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
const Payment = connect(
  mapStateToProps,
  mapDispatchToProps
)(_Payment);
export default Payment;

const TotalPrice = styled.div`
  border-top: 1px solid ${Colors.mainGrey};
  text-align: right;
  margin-bottom: 20px;

  .total-text {
    display: inline-block;
    padding-right: 15px;
  }

  .total-price-text {
    display: inline-block;
  }
`;

const CreditCardForm = styled.form`
  .card-number-wrapper {
    text-align: right;

    .card-logos {
      img {
        margin: 0 2px 5px 0;
      }
    }
  }

  .card-security {
    display: flex;
    justify-content: space-between;
  }

  .input-area {
    position: relative;

    .error-view {
      position: absolute;
      bottom: 0;
      color: #F44336;
      font-size: 1.2rem;
      left: 1px;
    }
  }

  .powered-by {
    display:flex;
    align-items: center;
    justify-content: space-between;

    .notice {
      display: flex;

      i {
        font-size: 16px;
        padding: 2px 5px 2px 0;
      }
    }

    .logo {
      background-color: #f76b1c;
      overflow: hidden;
      width: 138px;
      margin-right: -8px;
    }
  }
`;

const CustomPayButton = styled(PayButton)`
  background-color: #424242;
`;

const ProcessingBar = styled.div`
  padding: 30px 0;
`;

const styles = {
  cardsImage: {
    height: 26,
  },
  input: {
    height: 46,
    fontSize: '1.5rem',
  },
  input2: {
    height: 46,
    fontSize: 14,
    margin: '10px 0 0 0',
  },
  selectBlock: {
    // width: '100%',
    height: 46,
    border: `1px solid ${Colors.mainGrey}`,
    paddingLeft: 10,
    marginRight: '5%',
  },
  selectLabel: {
    fontWeight: 'normal',
    display: 'block',
    marginBottom: 0,
    color: Colors.fontBlack,
    fontSize: 14,
  },
  select: {
    border: 0,
    backgroundColor: Colors.mainWhite,
    padding: 0,
    margin: 0,
    color: Colors.fontGrey,
    fontSize: 14,
    position: 'relative',
    right: 3,
  },
  button: {
    height: 46,
    backgroundColor: Colors.mainOrange,
    fontSize: 14,
  },
  securedText: {
    fontSize: 14,
  },
  relativeBlock: {
    position: 'relative',
  },
};
